import { Menu } from '@nimbus-ds/patterns';
import classNames from 'classnames';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import NewAccountMenuContent from './components/NewAccountMenuContent';

interface AccountMenuProps {
  visible: boolean;
  device: 'mobile' | 'desktop';
}

function AccountMenuWeb({ visible, device }: AccountMenuProps): JSX.Element {
  const { isExpandedMenu } = useDesktopMenuContext();
  return (
    <div
      className={classNames('stratus--menu-container', 'stratus--submenu', {
        visible: visible,
      })}
    >
      <Menu expanded={isExpandedMenu}>
        <NewAccountMenuContent device={device} />
      </Menu>
    </div>
  );
}

export default AccountMenuWeb;
